var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.77778C0 2.75962 0.795938 3.55556 1.77778 3.55556C2.75962 3.55556 3.55556 2.75962 3.55556 1.77778C3.55556 0.795938 2.75962 0 1.77778 0C0.795938 0 0 0.795938 0 1.77778ZM1.77778 9.77778C0.795938 9.77778 0 8.98184 0 8C0 7.01816 0.795938 6.22222 1.77778 6.22222C2.75962 6.22222 3.55556 7.01816 3.55556 8C3.55556 8.98184 2.75962 9.77778 1.77778 9.77778ZM1.77778 16C0.795938 16 0 15.2041 0 14.2222C0 13.2404 0.795938 12.4444 1.77778 12.4444C2.75962 12.4444 3.55556 13.2404 3.55556 14.2222C3.55556 15.2041 2.75962 16 1.77778 16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeDots);
export default __webpack_public_path__ + "static/media/tree-dots.c7d77081d40960a9854c7d3bd9d5d745.svg";
export { ForwardRef as ReactComponent };